import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getEquipmentTypesAPI = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetAllEquipmentTypes`,
    method: 'get',
  });
};

export type EquipmentTypesResponse = {
  trailerKey: number;
  description: string;
}[];

export const fetchEquipmentTypes = async (): Promise<EquipmentTypesResponse> => {
  const response: AxiosResponse<EquipmentTypesResponse> = await getEquipmentTypesAPI();
  return response.data;
};
